export var ConnectionType;
(function (ConnectionType) {
    ConnectionType["GOOGLE_DRIVE"] = "GOOGLE_DRIVE";
    ConnectionType["ONEDRIVE"] = "ONEDRIVE";
    ConnectionType["SHAREPOINT"] = "SHAREPOINT";
    ConnectionType["DROPBOX"] = "DROPBOX";
    ConnectionType["BOX"] = "BOX";
    ConnectionType["WILEY"] = "WILEY";
    ConnectionType["GCAL"] = "GCAL";
    ConnectionType["GENERATED_IMAGE"] = "GENERATED_IMAGE";
    ConnectionType["GENERATED_VIDEO"] = "GENERATED_VIDEO";
    ConnectionType["NOTION_MCP"] = "NOTION_MCP";
    ConnectionType["OUTLOOK"] = "OUTLOOK";
    ConnectionType["LINEAR"] = "LINEAR";
    ConnectionType["LINEAR_ALT"] = "LINEAR_ALT";
    ConnectionType["SLACK"] = "SLACK";
    ConnectionType["GITHUB_MCP_DIRECT"] = "GITHUB_MCP_DIRECT";
    ConnectionType["ASANA_MCP_DIRECT"] = "ASANA_MCP_DIRECT";
    ConnectionType["ASANA_MCP_MERGE"] = "ASANA_MCP_MERGE";
    ConnectionType["ATLASSIAN_MCP_DIRECT"] = "ATLASSIAN_MCP_DIRECT";
    ConnectionType["LOCAL"] = "LOCAL";
    ConnectionType["SLACK_DIRECT"] = "SLACK_DIRECT";
    ConnectionType["JIRA_MCP_MERGE"] = "JIRA_MCP_MERGE";
    ConnectionType["CONFLUENCE_MCP_MERGE"] = "CONFLUENCE_MCP_MERGE";
    ConnectionType["MICROSOFT_TEAMS_MCP_MERGE"] = "MICROSOFT_TEAMS_MCP_MERGE";
    ConnectionType["FACTSET"] = "FACTSET";
    ConnectionType["ZOOM"] = "ZOOM";
})(ConnectionType || (ConnectionType = {}));
//# sourceMappingURL=types.js.map